<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary headline white--text">
                    Control Logic Optimization - Chilled Water Set Point
                </v-card-title>
                <v-card-text>
                    <equipment-selector v-model="equipment" :type-filter="typeFilter"></equipment-selector>
                    <date-range-selector v-model="range"></date-range-selector>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <control-logic-chilled-water-s-p :equipment="equipment" :range="range"></control-logic-chilled-water-s-p>
        </v-flex>
        <v-flex xs12>
            <v-card>
                <v-card-title class="accent white--text title">
                    Diagnostic Plots
                </v-card-title>
                <v-card-text>
                    <scatter-plot :equipment_name="equipment"
                                  variable-x="CHWR_Temp"
                                  variable-y="CHWS_Temp"
                                  :date-range="range"
                                  type="histogram2d"
                                  :on-only="true"
                    ></scatter-plot>

                    <scatter-plot :equipment_name="equipment"
                                  variable-x="CHWR_Temp"
                                  variable-y="CHWR_Temp"
                                  :date-range="range"
                                  type="histogram"
                                  :on-only="true"
                    ></scatter-plot>
                </v-card-text>

            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
  import ScatterPlot from '../components/ScatterPlot'
  import EquipmentSelector from '../components/EquipmentSelector'
  import ControlLogicChilledWaterSP from '../components/ControlLogicChilledWaterSP'
  import DateRangeSelector from '../components/DateRangeSelector'
  import moment from 'moment'
  import {mapGetters} from 'vuex'

  export default {
    name: 'ControlLogic',
    components: { DateRangeSelector, ControlLogicChilledWaterSP, EquipmentSelector, ScatterPlot },
      computed: {
          ...mapGetters([
              'controlLogicEquipType',
          ]),
          typeFilter(){
              if(this.controlLogicEquipType){
                  return this.controlLogicEquipType
              } else {
                  return  "chiller*"
              }
          }
      },
    data() {
      return {
        equipment: null,
        range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      }
    },
      beforeMount() {
          let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
          if(maxDate){
              this.range={
                  start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                  end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
              }
          }
      },
  }
</script>

<style scoped>

</style>
